import { useRef, useState, useEffect } from "react";
import beforeImg from "../assests/images/before.jpeg";
import afterImg from "../assests/images/after.jpeg";

export default function BeforeAfterSlider() {
  const containerRef = useRef(null);
  const [sliderPos, setSliderPos] = useState(50);
  const [isDragging, setIsDragging] = useState(false);

  const updatePosition = (clientX) => {
    if (!containerRef.current) return;

    const rect = containerRef.current.getBoundingClientRect();
    let x = clientX - rect.left;
    let percent = (x / rect.width) * 100;
    percent = Math.max(0, Math.min(100, percent));
    setSliderPos(percent);
  };

  const handleDown = (e) => {
    setIsDragging(true);
    updatePosition(e.clientX || e.touches[0].clientX);
  };

  const handleMove = (e) => {
    if (!isDragging) return;
    updatePosition(e.clientX || e.touches[0].clientX);
  };

  const handleUp = () => {
    setIsDragging(false);
  };

  useEffect(() => {
    window.addEventListener("mousemove", handleMove);
    window.addEventListener("mouseup", handleUp);
    window.addEventListener("touchmove", handleMove);
    window.addEventListener("touchend", handleUp);

    return () => {
      window.removeEventListener("mousemove", handleMove);
      window.removeEventListener("mouseup", handleUp);
      window.removeEventListener("touchmove", handleMove);
      window.removeEventListener("touchend", handleUp);
    };
  }, [isDragging]);

  return (
<section className="w-full pt-10 sm:pt-14 md:py-20 flex justify-center bg-white">

  <div className="max-w-8xl w-full px-4">
    
 <h2 className="section-heading text-2xl sm:text-3xl md:text-4xl 
               font-extrabold text-[#351F72] text-center">
  Why Is Better Than Others?
</h2>




    <div
      ref={containerRef}
      className="relative w-full 
                 h-[350px] sm:h-[450px] md:h-[600px] lg:h-[700px]
                 overflow-hidden rounded-2xl cursor-ew-resize select-none"
      onMouseDown={handleDown}
      onTouchStart={handleDown}
    >
      

      <img
        src={beforeImg}
        className="absolute inset-0 w-full h-full object-contain"
        draggable="false"
        alt="Bad refurbished laptop"
      />

      {/* Top Image */}
      <img
        src={afterImg}
        className="absolute inset-0 w-full h-full object-contain"
        draggable="false"
        alt="PC Care refurbished laptop"
        style={{
          clipPath: `inset(0 ${100 - sliderPos}% 0 0)`,
          WebkitClipPath: `inset(0 ${100 - sliderPos}% 0 0)`,
          willChange: "clip-path",
        }}
      />

      {/* Divider Line */}
      <div
        className="absolute top-0 bottom-0 w-[3px] bg-white "
        style={{
          left: `${sliderPos}%`,
        }}
      />

      {/* Handle */}
      <div
        className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2
                   w-12 h-12 bg-white rounded-full shadow-lg
                   flex items-center justify-center gap-2
                   pointer-events-none"
        style={{
          left: `${sliderPos}%`,
        }}
      >
        <i className="fa-solid fa-chevron-left text-gray-600 text-sm"></i>
        <i className="fa-solid fa-chevron-right text-gray-600 text-sm"></i>
      </div>

    </div>
  </div>
</section>


  );
}
